import {
  CREATE_CERTIFICATE,
  CREATE_CERTIFICATE_SUCCESS,
  CREATE_CERTIFICATE_ERROR,
  GET_CERTIFICATE,
  GET_CERTIFICATE_SUCCESS,
  GET_CERTIFICATE_ERROR,
  PATCH_CERTIFICATE,
  PATCH_CERTIFICATE_SUCCESS,
  PATCH_CERTIFICATE_ERROR,
  GET_CERTIFICATE_LIST,
  GET_CERTIFICATE_LIST_SUCCESS,
  GET_CERTIFICATE_LIST_ERROR,
  GET_CERTIFICATE_PAYMENT_SETTING,
  GET_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  GET_CERTIFICATE_PAYMENT_SETTING_ERROR,
  PATCH_CERTIFICATE_PAYMENT_SETTING,
  PATCH_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  PATCH_CERTIFICATE_PAYMENT_SETTING_ERROR,
  PATCH_CERTIFICATE_PRICE,
  PATCH_CERTIFICATE_PRICE_SUCCESS,
  PATCH_CERTIFICATE_PRICE_ERROR,
} from './type'

/**
 *
 * @param {*} collectionId
 */
export const createCertificateAction = (collectionId, callback) => {
  return {
    type: CREATE_CERTIFICATE,
    payload: { collectionId, callback },
  }
}

export const createCertificateSuccess = response => {
  return {
    type: CREATE_CERTIFICATE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 * @param {*} error
 */
export const createCertificateError = error => {
  return {
    type: CREATE_CERTIFICATE_ERROR,
    payload: { error },
  }
}

/**
 *
 * @param {*} collectionId
 * @param {*} callback
 */

export const getCertificateAction = (collectionId, callback) => {
  return {
    type: GET_CERTIFICATE,
    payload: { collectionId, callback },
  }
}

export const getCertificateSuccess = response => {
  return {
    type: GET_CERTIFICATE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 *
 * @param {*} error
 */
export const getCertificateError = error => {
  return {
    type: GET_CERTIFICATE_ERROR,
    payload: { error },
  }
}

/**
 *
 * @param {*} content
 * @param {*} callback
 */

export const patchCertificateAction = (content, callback, onError) => {
  return {
    type: PATCH_CERTIFICATE,
    payload: { content, callback, onError },
  }
}

export const patchCertificateSuccess = content => {
  return {
    type: PATCH_CERTIFICATE_SUCCESS,
    payload: { content },
  }
}

/**
 *
 * @param {*} error
 */
export const patchCertificateError = error => {
  return {
    type: PATCH_CERTIFICATE_ERROR,
    payload: { error },
  }
}

/**
 *
 * @param {*} callback
 * @param {*} selectedCollectionId
 */
export const getCertificateListAction = (selectedCollectionId, callback) => {
  return {
    type: GET_CERTIFICATE_LIST,
    payload: { selectedCollectionId, callback },
  }
}

export const getCertificateListSuccess = response => {
  return {
    type: GET_CERTIFICATE_LIST_SUCCESS,
    payload: { response },
  }
}

/**
 *
 * @param {*} error
 */
export const getCertificateListError = error => {
  return {
    type: GET_CERTIFICATE_LIST_ERROR,
    payload: { error },
  }
}

export const getCertificatePaymentSettingAction = (collectionId, callback) => ({
  type: GET_CERTIFICATE_PAYMENT_SETTING,
  payload: { collectionId, callback },
})

export const getCertificatePaymentSettingSuccess = response => ({
  type: GET_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  payload: { response },
})

export const getCertificatePaymentSettingError = error => ({
  type: GET_CERTIFICATE_PAYMENT_SETTING_ERROR,
  payload: { error },
})

export const patchCertificatePaymentSettingAction = (
  collectionId,
  content,
  callback,
) => ({
  type: PATCH_CERTIFICATE_PAYMENT_SETTING,
  payload: { collectionId, content, callback },
})

export const patchCertificatePaymentSettingSuccess = content => ({
  type: PATCH_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  payload: { content },
})

export const patchCertificatePaymentSettingError = error => ({
  type: PATCH_CERTIFICATE_PAYMENT_SETTING_ERROR,
  payload: { error },
})

export const patchCertificatePriceAction = (collectionId, data, callback) => ({
  type: PATCH_CERTIFICATE_PRICE,
  payload: { collectionId, data, callback },
})

export const patchCertificatePriceSuccess = content => ({
  type: PATCH_CERTIFICATE_PRICE_SUCCESS,
  payload: { content },
})

export const patchCertificatePriceError = error => ({
  type: PATCH_CERTIFICATE_PRICE_ERROR,
  payload: { error },
})
